import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DownloadIcon from '@mui/icons-material/Download';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { useGlobalContext } from '../../../Context/GlobalContext';
const PayrollSummary = () => {
    const { setSelectedTab,
        setStaffTab,
        branchData,
        departments,
        handleChangeBranch,
        handleChangeDepartment,
        selectBranch,
        selectDepartments,
        resetState } = useGlobalContext();
    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
    const [toggleDrop, setToggleDrop] = useState(false);


    function handledrop() {
        setToggleDrop(!toggleDrop)
    }

    const [toggleDrop1, setToggleDrop1] = useState(false);

    function handledrop1() {
        setToggleDrop1(!toggleDrop1)
    }


    const [isOpen, setIsOpen] = useState(false);

    const toggleCollapse = () => {
        setIsOpen(!isOpen);
    };

    const [isOpen1, setIsOpen1] = useState(false);

    const toggleCollapse1 = () => {
        setIsOpen1(!isOpen1);
    };

    const [isOpen2, setIsOpen2] = useState(false);

    const toggleCollapse2 = () => {
        setIsOpen2(!isOpen2);
    };

    const [isOpen3, setIsOpen3] = useState(false);

    const toggleCollapse3 = () => {
        setIsOpen3(!isOpen3);
    };

    const handleClickOutside = (event) => {
        handleClickOutside2(event)
        if (!event.target.closest('.three-dot')) {
            setToggleDrop(null);
        }
    };

    const handleClickOutside2 = (event) => {
        if (!event.target.closest('.three-dot2')) {
            setToggleDrop1(null);
        }
    };

    console.log("branchData", branchData);



    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const toggleOffCanvas = () => {
        setIsOffCanvasOpen(!isOffCanvasOpen);
    };

    return (
        <div className='mt-[20px]'>
            <div className='flex lg:flex-row xl:flex-row flex-col md:flex-col justify-between items-end gap-[15px] lg:gap-[0px]'>
                <div className='flex lg:flex lg:flex-row flex-col gap-[10px] lg:gap-[20px] w-full'>

                    <div className='xl:w-[240px]'>
                        <label htmlFor="" className='font-medium text-[14px]'>Payroll Month</label>
                        <input type="date" className='p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none' />
                    </div>
                    <div className='xl:w-[240px]'>
                        <label htmlFor="" className='font-medium text-[14px]'>Company Branches</label>
                        <select
                            value={selectBranch}
                            onChange={(e) => handleChangeBranch(e.target.value)}
                            className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
                        >
                            <option value="">Select a Branch</option>
                            {branchData.map((branch, index) => (
                                <option key={index} value={branch?.branchName}>
                                    {branch?.branchName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className='xl:w-[240px]'>
                        <label htmlFor="" className='font-medium text-[14px]'>Departments</label>
                        <select
                            value={selectDepartments}
                            onChange={(e) => handleChangeDepartment(e.target.value)} className='p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none'>
                            <option>Select a Department</option>
                            {departments.map((departmentName, index) => (
                                <option key={index} value={departmentName?.department_name}>
                                    {departmentName?.department_name}
                                </option>
                            ))}

                        </select>
                    </div>


                </div>
                <div className='w-full md:w-auto'>
                    <button onClick={resetState} className='justify-center w-full md:w-auto second-btn'>Reset</button>
                </div>
            </div>

            <div className='flex xl:flex-row flex-col justify-between'>



                <div className='xl:w-[60%]'>
                    <div className='bg-white set-shadow mt-[20px] p-[20px] rounded-md'>
                        <button onClick={() => { setSelectedTab(1) }} className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b w-full hover:text-[#000] transition'>
                            <p className='w-[107px] xl:w-[300px] text-[13px] text-left'>Total Payroll <InfoIcon /> </p>
                            <p className='text-[13px]'>0 Staff</p>
                            <p className='text-[13px]'>₹ 0.00</p>
                        </button>

                        <button onClick={() => { setSelectedTab(1) }} className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b w-full hover:text-[#000] transition'>
                            <p className='w-[107px] xl:w-[300px] text-[13px] text-left'>Paid <InfoIcon /> </p>
                            <p className='text-[13px]'>0 Staff</p>
                            <p className='text-[13px]'>₹ 0.00</p>
                        </button>

                        <button onClick={() => { setSelectedTab(1) }} className='flex justify-between hover:bg-[#f4f5f9] p-[10px] pb-[10px] w-full hover:text-[#000] transition' >
                            <p className='w-[107px] xl:w-[300px] text-[13px] text-left'>Pending <InfoIcon /> </p>
                            <p className='text-[13px]'>0 Staff</p>
                            <p className='text-[13px]'>₹ 0.00</p>
                        </button>

                    </div>

                    <div className='bg-white set-shadow mt-[20px] rounded-md'>

                        <h2 className='p-[20px] border-b'>Earning Details</h2>
                        <div className='p-[20px]'>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Work Basis Payment </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Incentives </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Reimbursement                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Bonus                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Overtime Pay
                                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between hover:bg-[#f4f5f9] p-[10px] pb-[10px] hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Other Earnings
                                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>

                        </div>



                    </div>




                    <div className='bg-white set-shadow mt-[20px] rounded-md'>
                        <div className='flex justify-between items-center p-[20px] border-b'>
                            <h2 className=''>Statutory Compliance Details</h2>
                            <div className='relative'>
                                <button className='bg-[#e5e7eb] p-[3px] rounded-md font-normal text-[#000] text-[16px] three-dot' onClick={handledrop}><MoreVertIcon /></button>

                                {
                                    toggleDrop &&

                                    <div className="right-[-10px] md:left-[-302px] lg:left-[-302px] xl:left-[-270px] z-10 absolute bg-white ring-opacity-5 set-shadow mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-[300px] md:w-[322px] lg:w-[322px] xl:w-[300px] origin-top-right focus:outline-none payroll-dots" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                        <div className="py-1" role="none">
                                            <NavLink to="/calender" className="block items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1" id="menu-item-1"><DownloadIcon className='font-normal text-[#27004a] text-[18px]' /> Provident Fund Challan Report</NavLink>
                                            <NavLink to="/day-wise" className="block items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1" id="menu-item-0"><DownloadIcon className='font-normal text-[#27004a] text-[18px]' /> ESI Challan Report</NavLink>
                                            <NavLink to="/week-wise" className="block items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1" id="menu-item-1"><DownloadIcon className='font-normal text-[#27004a] text-[18px]' /> Tax Deducated at Source Report</NavLink>

                                        </div>

                                    </div>
                                }
                            </div>
                        </div>
                        <div className='p-[20px]'>
                            <div>
                                <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                    <p className='w-[107px] xl:w-[300px] text-[13px]'>Total Provident Fund
                                    </p>
                                    <p className='pl-[31px] text-[13px]'>0 Staff</p>
                                    <p className='relative right-[-23px] flex items-center gap-[10px] text-[13px]'>₹ 0.00
                                        <KeyboardArrowDownIcon className={`get-icon ${isOpen ? "rotate-0" : "rotate-180"} border rounded-full border-[#000] arrow-down`} onClick={toggleCollapse} />
                                    </p>


                                </div>

                                <div
                                    className={`transition-all pl-[20px] pr-[20px] duration-500 ease-in-out overflow-hidden ${isOpen ? "max-h-screen" : "max-h-0"
                                        }`}
                                >
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            Employer Contribution
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            Employee Contribution
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            EDLI & Admin Charges
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                    <p className='w-[107px] xl:w-[300px] text-[13px]'>Total Labour Welfare Fund Tax
                                    </p>
                                    <p className='pl-[31px] text-[13px]'>0 Staff</p>
                                    <p className='relative right-[-23px] flex items-center gap-[10px] text-[13px]'>₹ 0.00
                                        <KeyboardArrowDownIcon className={`get-icon ${isOpen2 ? "rotate-0" : "rotate-180"} border rounded-full border-[#000] arrow-down`} onClick={toggleCollapse2} />
                                    </p>


                                </div>

                                <div
                                    className={`transition-all pl-[20px] pr-[20px] duration-500 ease-in-out overflow-hidden ${isOpen2 ? "max-h-screen" : "max-h-0"
                                        }`}
                                >
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            Employer Contribution
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            Employee Contribution
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div>
                                <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                    <p className='w-[107px] xl:w-[300px] text-[13px]'>Total Employees' State Insurance

                                    </p>
                                    <p className='pl-[31px] text-[13px]'>0 Staff</p>
                                    <p className='relative right-[-23px] flex items-center gap-[10px] text-[13px]'>₹ 0.00
                                        <KeyboardArrowDownIcon className={`get-icon ${isOpen1 ? "rotate-0" : "rotate-180"} border rounded-full border-[#000] arrow-down`} onClick={toggleCollapse1} />
                                    </p>


                                </div>

                                <div
                                    className={`transition-all pl-[20px] pr-[20px] duration-500 ease-in-out overflow-hidden ${isOpen1 ? "max-h-screen" : "max-h-0"
                                        }`}
                                >
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            Employer Contribution
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>
                                    <div className="flex justify-between p-[5px]">
                                        <p className='text-[13px]'>
                                            Employee Contribution
                                        </p>
                                        <p className='text-[13px]'>
                                            ₹ 0.00
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Bonus                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>

                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Total Professional Tax
                                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between hover:bg-[#f4f5f9] p-[10px] pb-[10px] hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Total Tax Deducted at Source  <InfoIcon />

                                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>

                        </div>
                    </div>


                    <div className='bg-white set-shadow mt-[20px] rounded-md'>
                        <div className='flex justify-between p-[20px] border-b'>
                            <h2 className=''>Total Loan Amount</h2>
                            <div className='relative'>
                                <button className='bg-[#e5e7eb] p-[3px] rounded-md font-normal text-[#000] text-[16px] three-dot2' onClick={handledrop1}><MoreVertIcon /></button>

                                {
                                    toggleDrop1 &&

                                    <div className="right-[-10px] md:left-[-302px] lg:left-[-302px] xl:left-[-270px] z-10 absolute bg-white ring-opacity-5 set-shadow mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-[300px] md:w-[322px] lg:w-[322px] xl:w-[300px] origin-top-right focus:outline-none payroll-dots" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                        <div className="py-1" role="none">
                                            <NavLink to="/calender" className="block items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1" id="menu-item-1"><DownloadIcon className='font-normal text-[#27004a] text-[18px]' /> Loan Report</NavLink>

                                        </div>

                                    </div>
                                }
                            </div>
                        </div>
                        <div className='p-[20px]'>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Given </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between items-center hover:bg-[#f4f5f9] p-[10px] pb-[10px] border-b hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Received </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>
                            <div className='flex justify-between hover:bg-[#f4f5f9] p-[10px] pb-[10px] hover:text-[#000] transition'>
                                <p className='w-[107px] xl:w-[300px] text-[13px]'>Pending Loan Amount
                                </p>
                                <p className='text-[13px]'>0 Staff</p>
                                <p className='text-[13px]'>₹ 0.00</p>
                            </div>


                        </div>
                    </div>
                </div>

                <div className='w-full xl:w-[35%]'>
                    <div className='bg-white set-shadow mt-[20px] rounded-md'>
                        <h2 className='p-[20px] border-b font-normal'>Pending Actions</h2>
                        <Link to="/staff-menu" onClick={() => { setStaffTab(2) }} className='flex flex items-center gap-[5px] p-[20px] pt-[10px] pb-[10px] border-b text-[12px]'>Verify Bank Account (1) <ArrowRightAltIcon /></Link>
                        <Link to="#" className='flex gap-[5px] p-[20px] pt-[10px] pb-[10px] border-b text-[12px]'>Finalize Payroll (0) </Link>
                        <Link to="#" className='flex gap-[5px] p-[20px] pt-[10px] pb-[10px] border-b text-[12px]'>Add Salary Details (0)</Link>
                        <Link to="#" className='flex gap-[5px] p-[20px] pt-[10px] pb-[10px] border-b text-[12px]'>Approve Leaves (0) </Link>


                    </div>

                    <div className='bg-white set-shadow mt-[20px] rounded-md'>
                        <h2 className='flex justify-between p-[20px] border-b font-normal' onClick={toggleCollapse3}  >Getting Started<KeyboardArrowDownIcon className={` get-icon ${isOpen3 ? "rotate-0" : "rotate-180"} border rounded-full border-[#000] arrow-down`} />
                        </h2>
                        <div
                            className={`transition-all pl-[20px] pr-[20px] duration-500 ease-in-out overflow-hidden ${isOpen3 ? "max-h-screen" : "max-h-0"
                                }`}
                        >

                            <div className="flex justify-between p-[10px]">
                                <Link to="#" className='hover:bg-[#f4f5f9] p-[10px] rounded-md w-full text-[13px] transitions'>


                                    <YouTubeIcon />

                                    How to use SalaryBox Payroll?
                                </Link>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default PayrollSummary